import { Fab as Chat } from "@material-ui/core"
import React, { useState } from "react"
import { ThemeContext } from "styled-components";
import AssistentePessoal from "../pages/assistente-pessoal/AssistentePessoalModal";
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';


const LoadAssistent = () => {

	const [open, setOpen] = useState(false);

	const handleClickOpen = (e) => {
		setOpen(true);
		e.stopPropagation();
	};

	const handleClickClose = (e) => {
		setOpen(false);
		e.stopPropagation();
	};

	const HtmlTooltip = withStyles((theme) => ({
		tooltip: {
			fontSize: "14px",
		}
	}))(Tooltip);



	return (
		<ThemeContext.Consumer>
			{theme => (
				<HtmlTooltip placement="top" title="Como posso te ajudar?" fontSize="20px" arrow>
					<Chat
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							position: 'fixed',
							textAlign: "center",
							bottom: 60,
							right: 15,
							backgroundColor: theme.primary,
							color: "#ffffff",
							fontWeight: "600",
							outline: 'none',
							width: '48px',
							height: '48px'
						}}
						target="_blank"
						variant="extended"
						onClick={(e) => handleClickOpen(e)}
					>
						<i
							className={theme.iconAssistem ? ("") : ("fas fa-solid fa-comment-dots")}
							style={{
								color: '#fff',
								fontSize: '20px',
								margin: '0'
							}}
						/>
						{open && <AssistentePessoal handleClickClose={handleClickClose} open={open} />}
					</Chat>
				</HtmlTooltip>
			)}
		</ThemeContext.Consumer>
	)
}

export default LoadAssistent
